module.exports = __webpack_public_path__ + "img/316.b1567054.jpg";